import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import {
    ordersSetFavoriteFetch,
    ordersSetReservationOver
} from './../store/orders/actions';

import classNames from './../utils/classNames';
import formatTime from './../utils/formatTime';

import Icon from './Icon';

class OrdersTableRow extends Component {
    constructor(props) {
        super(props);

        this.onClickFavorite = this.onClickFavorite.bind(this);
    }

    onOpenClick(event) {
        event.stopPropagation();
    }

    onClickFavorite(event) {
        const { order, setFavorite } = this.props;

        setFavorite(!order.is_favorite);

        event.stopPropagation();
    }

    renderTag() {
        const { order } = this.props;
        const { grade_priority } = order;

        if (!grade_priority) {
            return (
                <span className="badge-priority badge-priority--low">Low</span>
            );
        }

        if (grade_priority <= 2) {
            return (
                <span className="badge-priority badge-priority--low">Low</span>
            );
        }
        if (grade_priority <= 4) {
            return (
                <span className="badge-priority badge-priority--medium">Medium</span>
            );
        }
        return (
            <span className="badge-priority badge-priority--high">High</span>
        );
    }

    renderLastGraded() {
        const { order } = this.props;
        if (!order.writer_last_graded_at) {
            return null;
        }
        const text = formatTime(order.writer_last_graded_at, 'mdhm_tn');
        const isOverMonth = moment().diff(moment(order.writer_last_graded_at), 'months') >= 1;
        const className = classNames({ 'text-warning': isOverMonth })
        return (
            <span className={className}>{text}</span>
        );
    }

    render() {
        const { order, className, onClick } = this.props;
        const rowClassName = classNames(className, { 'not-read': !order.is_viewed }, { 'disabled': order.isReservationOver }, { 'is-recommended': order.is_recommended });
        const btnClassName = classNames('btn', 'btn-empty', { 'active': order.is_favorite });
        return (
            <div className={rowClassName} onClick={onClick}>
                <div className="col-1 ta-center">
                    <button type="button" className={btnClassName} disabled={order.isFetchingFavorite} onClick={this.onClickFavorite}>
                        <Icon className="svg-icon" iconName="saved-star" />
                    </button>
                </div>
                <div className="col-5">
                    {order.number}
                    <a href={`/order/${order._id}`} target="_blank" rel="noopener noreferrer" onClick={this.onOpenClick}>
                        <Icon className="svg-icon" iconName="open-new-window" />
                    </a>
                </div>
                <div className="col-6">{order.subject}</div>
                <div className="col-3">{order.type}</div>
                <div className="col-3">${order.pregrader_price.toFixed(2)}</div>
                <div className="col-2">{order.size}</div>
                <div className="col-4">{this.renderLastGraded()}</div>
                <div className="col-2">{order.writer_last_graded_count}/10</div>
                <div className="col-4">{this.renderTag()}</div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const order = state.orders[ownProps.number];
    return { order };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setFavorite: value => dispatch(ordersSetFavoriteFetch(ownProps.number, value)),
        setReservationOwer: () => dispatch(ordersSetReservationOver(ownProps.number))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersTableRow);



// WEBPACK FOOTER //
// ./src/components/OrdersTableRow.js